import Model, { encoders, ID } from 'src/models/model'
import Modifier from 'src/models/modifier-set/Modifier'
import ModifierSet from 'src/models/modifier-set/ModifierSet'
import ItemOrderItem from 'src/models/order-item/ItemOrderItem'

export default class ItemOrderItemModifier extends Model {
  static name = 'ItemOrderItemModifier'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      itemOrderItem: {
        type: ItemOrderItem,
        output: true,
        encode: encoders.hasOne,
        reference: true
      },
      modifier: {
        type: Modifier,
        encode: encoders.hasOne,
        reference: true
      },
      modifierSet: {
        type: ModifierSet,
        encode: encoders.hasOne,
        reference: true
      },
      price: {
        type: Number,
        output: true,
        default: 0
      }
    }
  }

  get description () {
    return this.modifier.name + (this.price > 0 ? `(${this.i18n.n(this.price, 'currency')})` : '')
  }
}
